module.exports = __webpack_public_path__ + "img/2.02234bfe.jpg";